<template>

  <div>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="roles"
      hide-default-footer
      show-select
      fixed-header
      height="350"
      class="roles-table"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      disable-pagination
    >

      <template #header.name="{ header }">

        <div class="d-flex justify-space-between align-center">

          <span>{{ header.text }}</span>

          <TwoArrowSort class="agents-table--sort-icon" />

        </div>

      </template>

    </v-data-table>

  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { formatValues } from '@/mixins/formatValues.mixin';
import TwoArrowSort from '@/components/common/icons/TwoArrowSort';

export default {
  name: 'RolesTable',
  components: {
    TwoArrowSort
  },
  mixins: [formatValues],
  props: {
    roles: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      singleSelect: true,
      selected: [],
      sortBy: ['name'],
      sortDesc: false
    };
  },
  computed: {
    ...mapGetters('site', ['selectZone']),
    headers() {
      return [
        {
          text: 'Roles',
          divider: true,
          align: 'start',
          sortable: false,
          width: '100%',
          value: 'description'
        }
      ];
    }
    // selectedRoles: {
    //   get() {
    //     return this.roles.filter(role => role.status);
    //   },
    //   set(newValue) {
    //     this.selected = newValue.map(item => {
    //       item.status = true;
    //       return item;
    //     });
    //   }
    // }
  },
  watch: {
    selected: {
      immediate: true,
      deep: false,
      handler(newValue, oldValue) {
        if (
          oldValue !== null &&
          newValue !== null &&
          oldValue !== undefined &&
          newValue !== undefined &&
          (newValue.some((value, index) => value !== oldValue[index]) || newValue.length !== oldValue.length)
        ) {
          // Check if not initial render or actual change inside arrays
          const roles = newValue.map(item => item.id);
          const siteId = this.selectZone;
          this.getRoleStatus({ roles, siteId });
          // this.addNewRoleToAccount({ id: this.selectedId, siteId, data: { roles } });
        }
      }
    },
    selectZone: {
      immediate: true,
      deep: false,
      handler() {
        this.updateRoles();
      }
    },
    roles: {
      immediate: true,
      deep: false,
      handler() {
        this.updateRoles();
      }
    }
  },
  mounted() {
    this.updateRoles();
  },
  methods: {
    ...mapActions('accounts', ['getRoleStatus']),
    updateRoles() {
      if (this.roles.some(role => role.status)) {
        this.selected = this.roles.filter(role => role.status);
      } else {
        this.selected = [];
      }
    }
  }
};
</script>

<style lang="scss">
.roles-table {
  table-layout: fixed;
  margin-bottom: 3rem !important;

  .theme--light.v-input--selection-controls.v-input--is-disabled.v-input--is-label-active .v-icon {
    color: #3dd598 !important;
  }

  .v-data-table-header__icon {
    display: none;
  }

  .v-input--selection-controls__input {
    .v-icon {
      color: #3dd598 !important;
    }
  }

  .mdi-checkbox-blank-outline {
    color: red !important;
  }

  &--sort-icon {
    min-width: 24px;
    min-height: 24px;
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }
  td:nth-child(1) {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  tr:last-child {
    td {
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
  }

  thead {
    th {
      background-color: white;
      border-top: thin solid rgba(0, 0, 0, 0.12);
    }

    th:nth-child(1) {
      border-left: thin solid rgba(0, 0, 0, 0.12);
    }
  }
}
</style>

